import React, { Component } from "react";
import request from "superagent";
import { url_endpoint, url_s3 } from "../../config";
import authHeader from "../Utils/AuthHeader";
import moment from "moment";
import { height, flexbox } from "@material-ui/system";
import LoaderSpinner from "../../componentes/LoaderSpinner";
import IconButton from '@material-ui/core/IconButton';
import ButtonLogout from "../../componentes/ButtonLogout";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import checkLogin from "../Utils/checkLogin";

class Pedidos extends Component {


    constructor(props) {
        super(props);
        this.state = {
            windowHeight: 0,

            dados: [],
            dadosBack: [],
            item: {
                id: -1
            },
            audio: "",
            imagem: "",
            filter: _ => true,
            id_client_filtro: -1,
            clientes: [],
            loading: false,
            actualPage: 0,
            minutos: 0
        }
    }



    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    async componentDidMount() {
        try {
            await checkLogin(true)
            window.addEventListener('resize', this.handleResize)

            this.setState({ loading: true });

            const res = await request.get(url_endpoint + "pedido/all/" + this.state.actualPage).set(authHeader());
            this.setState({ dados: res.body });
            this.setState({ dadosBack: res.body });

            this.setState({ loading: false });

            const res_cliente = await request.get(url_endpoint + 'cliente/all').set(authHeader());
            this.setState({ clientes: res_cliente.body });
        } catch (error) {
            alert(error)
        }


    }

    salvarPostcast = async () => {
        try {
            if (this.state.audio == '') {
                return alert('O áudio é necessário')
            }

            this.setState({ loading: true });

            await request.post(url_endpoint + "pedido/postcast").set(authHeader())
                .attach("audio", this.state.audio)
                .attach("imagem", this.state.imagem)
                .field("id", this.state.item.id)
                .field("minutos", this.state.minutos);

            this.setState({ loading: false });

            const dados = this.state.dados;
            const index = dados.findIndex(i => i.id === this.state.item.id);
            dados[index].produzido = true;
            this.setState({ dados });
        } catch (err) {
            alert(err.response.text);
        }
    }

    changeFilterClients = async (event) => {
        //filtro nos itens de memoria  

        const value = parseInt(event.target.value);
        this.setState({ id_client_filtro: value });

        if (value === -1) {
            this.setState({ dados: this.state.dadosBack });

        } else {
            let clientsExist = this.state.dadosBack.filter(pedid => pedid.Cliente.id == value);
            this.setState({ dados: clientsExist });
        }

    }


    changeFilterStatus = async (event) => {
        //filtro nos itens de memoria 

        const value = parseInt(event.target.value);
        this.setState({ cod_filtro_status: value });


        if (value == 0) {
            this.setState({ filter: evt => !evt.produzido })
        } if (value == 1) {
            this.setState({ filter: evt => evt.produzido == true })
        } else if (value == -1) {
            this.setState({ filter: _ => true })
        }


    }

    handleResize = () => this.setState({
        windowHeight: window.innerHeight
    });

    onClickCopy = () => {
        alert("Copiado para a área de transferência!");
    }

    nextPage = async () => {
        this.setState({ loading: true })
        const lastPage = this.state.actualPage
        const newPage = lastPage + 1
        const res = await request.get(url_endpoint + "pedido/all/" + newPage).set(authHeader());
        if (res.body.length > 0) {
            this.setState({ loading: false, dados: res.body, actualPage: newPage })
        }
        else {
            this.setState({ loading: false })
            window.alert('Já está na última página.')
        }
    }

    prevPage = async () => {
        const lastPage = this.state.actualPage
        const newPage = lastPage - 1
        if (newPage < 0) {
            window.alert('Já está na primeira página')
        }
        else {
            this.setState({ loading: true, actualPage: newPage })
            const res = await request.get(url_endpoint + "pedido/all/" + newPage).set(authHeader());
            this.setState({ loading: false, dados: res.body })
        }
    }

    render() {
        const intFrameHeight = (window.innerHeight - 42) + "px";
        return (
            <div style={{ height: intFrameHeight, overflow: "auto" }} >

                {this.state.loading &&
                    <LoaderSpinner />
                }

                <div className={"pedidos"}>

                    <div style={{ textAlign: "center" }}>

                        <select className={"combobox-filtro"} onChange={evt => this.changeFilterClients(evt)} value={this.state.id_client_filtro} width={200}>
                            <option value={-1}>Filtro por Clientes</option>
                            {this.state.clientes.map((item, x) => {
                                return (
                                    <option value={item.id}>{item.nome}</option>
                                )
                            })}
                        </select>

                        <select className={"combobox-filtro"} onChange={evt => this.changeFilterStatus(evt)} value={this.state.cod_filtro_status} width={200}>
                            <option value={-1}>Filtro Ações</option>
                            <option value={0} >Não produzido</option>
                            <option value={1} >Já produzido</option>
                        </select>

                    </div>

                    <div className={"button-logout"}>
                        <IconButton >
                            <ButtonLogout />
                        </IconButton>
                    </div>




                    <h1>Pedidos</h1>
                    <br />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
                        <button onClick={this.prevPage} style={{ marginRight: '10px' }}>Página Anterior</button>
                        <button onClick={this.nextPage}>Próxima página</button>
                    </div>
                    {this.state.item.id >= 0 &&
                        <div>
                            <h3>Produzir Áudio</h3>
                            <b>Imagem de capa (só definir se necessário):</b> <input type={"file"} accept="image/*" onChange={evt => this.setState({ imagem: evt.target.files[0] })} /><br />
                            <b>Áudio: </b> <input type={"file"} accept='audio/*' onChange={evt => {
                                let audioDuration
                                const newAudio = evt.target.files[0]
                                const durationAudio = new Audio()
                                durationAudio.onloadedmetadata = evt => {
                                    audioDuration = durationAudio.duration
                                    this.setState({ audio: newAudio, minutos: Math.round(audioDuration) })
                                }
                                durationAudio.src = URL.createObjectURL(newAudio)

                            }} /><br />
                            <b>Minutos: </b> <input type={"number"} min={0} readOnly value={this.state.minutos} /><br />
                            <button onClick={this.salvarPostcast}>SALVAR ÁUDIO</button>
                        </div>
                    }

                    <div className={"content_dados"}>
                        <table className={"custom-table custom-table-horizontal custom-table-highlight"}>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Título</th>
                                    <th>Post</th>
                                    <th>Descrição Agregadores</th>
                                    <th>Origem</th>
                                    <th>Imagem</th>
                                    <th>Data</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>

                                {this.state.dados.filter(this.state.filter).map((item) => {
                                    return (
                                        <tr>
                                            <td>{item.id}  </td>
                                            <td>{item.Cliente.nome}</td>
                                            <td>{item.titulo}</td>
                                            <td>
                                                <input value={item.post} style={{ width: "100%", height: "30px" }}></input>

                                                <CopyToClipboard text={item.post} onCopy={() => this.onClickCopy()}>
                                                    <button className={"btn-copy"}>Copiar</button>
                                                </CopyToClipboard>
                                            </td>
                                            <td>
                                                <input value={item.descricao_agregadores} style={{ width: "100%", height: "30px" }}></input>

                                                <CopyToClipboard text={item.descricao_agregadores} onCopy={() => this.onClickCopy()}>
                                                    <button className={"btn-copy"}>Copiar</button>
                                                </CopyToClipboard>
                                            </td>
                                            <td>{item.url}</td>
                                            <td width={100}><img src={item.imagem.includes('digitalocean') ? item.imagem : (url_s3 + item.imagem)} width={100} /></td>
                                            <td>{moment(item.createdAt).format("D/M/Y H:m:s")}</td>
                                            <td>
                                                {!item.produzido ?
                                                    <button onClick={_ => this.setState({ item })}> {"Produzir"}</button>
                                                    :
                                                    <span>Já produzido</span>
                                                }
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>


        )
    }
}

export default Pedidos;
